
const config = {
    width: 0,
    height: 0,
    /**
     * @type Prando
     */
    random: null
};

export default config
